export const configs = {
    maximumDaysOutbound: 7,
    maximumDaysInbound: 7,
}